import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { SelectInput } from '../core/components/forms';
import Form from '../core/components/forms/Form';
import * as actions from './store/actions';

// interface CarmenUserSelectProps {
//   carmenUser?: object
//   users?: unknown[]
//   updateCarmenUser?(...args: unknown[]): unknown
// }

const CarmenUserSelect = props => {
  const {
    users,
    carmenUser,
    updateCarmenUser,
  } = props;

  const { userId } = carmenUser;

  const [loading, setLoading] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);

  const handleSubmit = async (id, value) => {
    setLoading(true);
    await updateCarmenUser({ id, userId: value });
    setShowCloseButton(!isEmpty(value));
    setLoading(false);
  };

  useEffect(() => {
    if (userId) {
      setShowCloseButton(true);
    }
  }, [userId]);

  return (
    <Form
      initialValues={ { userId } }
      onSubmit={ handleSubmit }
    >
      { ({ values, handleChange }) => (
        <SelectInput
          name='userId'
          placeholder='Пользователь'
          data={ users }
          dataTitle='fullName'
          dataValue='id'
          loading={ loading }
          onChange={ async e => {
            handleChange(e);
            await handleSubmit(carmenUser.id, e.target.value);
          } }
          isClearable={ showCloseButton }
          className={ !values.userId ? 'unselected' : null }
        />
      ) }
    </Form>

  );
};

const mapDispatchToProps = dispatch => ({
  updateCarmenUser: payload => dispatch(actions.updateCarmenUser(payload)),
});

export default connect(null, mapDispatchToProps)(CarmenUserSelect);
